import React from "react";
import { NavLink } from "react-router-dom";
import Icon from "../icons/Icon";
import { paths } from "../../routes/paths";

function Sidebar({ collapsed, canToggle, onToggle }) {
  return (
    <aside className="sidebar">
      {/* NavLink já marca aria-current="page" no item ativo. O rótulo é um
          <span> próprio porque a sidebar compacta o recorta com .sr-only em
          vez de escondê-lo — display:none apagaria o nome acessível. */}
      <nav className="nav" aria-label="Navegação principal">
        <NavLink
          className={({ isActive }) => (isActive ? "nav-item is-active" : "nav-item")}
          to={paths.projects}
        >
          <Icon name="folder" />
          <span className="nav-label">Projetos</span>
        </NavLink>
      </nav>

      {/* Abaixo do recorte de 1100px a sidebar é compacta à força, e o controle
          sai de cena em vez de prometer uma expansão que o layout não entrega. */}
      {canToggle && (
        <button
          type="button"
          className="nav-item nav-toggle"
          aria-expanded={!collapsed}
          onClick={onToggle}
        >
          <Icon name={collapsed ? "chevron-right" : "chevron-left"} />
          <span className="nav-label">{collapsed ? "Expandir menu" : "Recolher menu"}</span>
        </button>
      )}
    </aside>
  );
}

export default Sidebar;
